import { PageViewEventLogger } from '@repo/tracking-service';
import { AuthGuard } from '@repo/user-session';
import { useRouter } from 'next/router';

import Layout from '@/components/layout/Layout';
import { RefundResultManual } from '@/components/tax-refund/result/Manual/RefundResultManual';

const RefundDepositResultManual = () => {
  const router = useRouter();
  const goBack = () => {
    router.back();
  };

  return (
    <AuthGuard>
      <PageViewEventLogger pageName={'deposit-guide'} />
      <Layout
        leftIcon={{ icon: 'back', clickEvent: { name: 'deposit-guide_topnav_back' } }}
        className={'flex min-h-screen flex-col'}
        mainClassName={'flex flex-1'}
      >
        <RefundResultManual />
      </Layout>
    </AuthGuard>
  );
};

export default RefundDepositResultManual;
